import React, { useEffect, useMemo, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import UploadVideo from "./UploadVideo";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import DoneIcon from "@mui/icons-material/Done";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
    borderColor: "#ccc",
    boxShadow: "none",
    padding: "4px 8px",
  }),
  menu: (base) => ({
    ...base,
    maxHeight: 160,
    overflowY: "auto",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 160, // scrolling height
    overflowY: "auto", // enable scroll
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: state.isFocused ? "#f0eaff" : "#fff",
    color: "#000",
    padding: "10px",
  }),
};

const AnnouncementBannerEdit = () => {
  const naviagte = useNavigate();
  const location = useLocation();
  const { state, pathname } = location;
  const isEdit = state?.type === "edit";
  const videoData = state;
  const video_prob_Data = {
    userType: {
      label: videoData?.userType,
      value: videoData?.userType === "User" ? 1 : 2,
    },
    Type: {
      label: videoData?.announcement_type === 1 ? "Video" : "Image",
      value: videoData?.announcement_type,
    },
    language: "",
    video: "",
    thumbnail: "",
    title: "",
    displayFor: [],
  };
  const initial_empty_data = {
    userType: {
      label: videoData?.userType,
      value: videoData?.userType === "User" ? 1 : 2,
    },
    Type: {
      label: videoData?.announcement_type === 1 ? "Video" : "Image",
      value: videoData?.announcement_type,
    },
    language: "",
    video: "",
    thumbnail: "",
    title: "",
    displayFor: [],
  };
  const [data, setData] = useState(
    videoData ? video_prob_Data : initial_empty_data,
  );
  const [videoBannerList, setVideoBannerList] = useState(state?.data ?? []);

  var [isVideo, setIsVideo] = useState(data.Type?.label === "Video");
  const [optionList, setOptionList] = useState({
    userType: [
      { label: "User", value: 1 },
      { label: "Hotels", value: 2 },
    ],
    Type: [
      { label: "Video", value: 1 },
      { label: "Image", value: 2 },
    ],
    languages: [],
    displayFor: ["Owner", "Receptionist"],
  });
  const [errors, setErrors] = useState(false);
  const thumpRef = useRef(null);

  const handleChangeData = (lan, d) => {
    if (!lan && !d) return;
    let found =
      d ?? videoBannerList?.find((item) => item?.language === lan?.id);
    setData((prev) => ({
      ...prev,
      language: lan,
      video: found?.video ?? "",
      thumbnail: found?.image ?? found?.thumbnail_image ?? "",
      title: found?.title ?? "",
      displayFor: found?.display_for ?? [],
    }));
  };

  const updateState = (d) => {
    console.log("update state", d);
    let find = videoBannerList?.find((item) => item?.id === d?.id);
    let modifiedList = find
      ? [...videoBannerList?.map((item) => (item?.id === d?.id ? d : item))]
      : [...videoBannerList, d];
    setVideoBannerList(modifiedList);
    naviagte(pathname, {
      state: {
        ...state,
        data: modifiedList,
      },
      replace: true,
    });
  };

  const handleChange = (name, value) => {
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const handleCheckBoxChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: [
        ...(prev?.[name]?.includes(value)
          ? prev?.[name]?.filter((item) => item !== value)
          : [...prev?.[name], value]),
      ],
    }));
  };

  //api functions

  const getLanguages = async () => {
    let res = await get(`${URLS.LANGUAGE_LIST}?type=1`);
    if (res?.status === "success") {
      let d = res?.data
        ?.filter((item) => item?.status)
        ?.map((item) => ({ ...item, value: item?.id, label: item?.name }));

      setOptionList((prev) => ({
        ...prev,
        languages: d,
      }));
      handleChangeData(d?.[0]);
    }
  };

  useEffect(() => {
    getLanguages();
  }, []);

  const Submit = async () => {
    let { Type, displayFor, language, thumbnail, title, userType, video } =
      data;

    let error = false;
    console.log("data check", data);
    Object.entries(data).forEach((value) => {
      let key = value[0];
      let val = value[1];
      if (!val && key !== "video") error = true;
    });
    if (isVideo && !video) {
      setErrors(true);
      return;
    }
    if (
      error ||
      (data?.userType?.value === 2 && data.displayFor?.length == 0)
    ) {
      setErrors(true);
      return;
    }

    const formData = new FormData();

    formData.append("language", language?.id);
    formData.append("type", userType?.value);
    formData.append("announcement_type", Type?.value);
    formData.append("title", title);
    displayFor.forEach((item) => {
      formData.append("display_for", item);
    });

    if (typeof data?.thumbnail !== "string")
      formData.append("image", thumbnail);
    if (typeof data?.video !== "string") formData.append("video_file", video);
    let url = URLS.ANNOUNCEMENT_BANNER_UPDATE;
    let method = isEdit ? put : post;
    let res = await method(url, formData);
    console.log("onsubmit", data, res);
    if (res?.status === "success") {
      toast.success(res?.message);
      handleChangeData(language, res?.data);
      updateState(res?.data);
    }
  };

  return (
    <div>
      <Topbar header={"Announcement Banner/video"} back={true} />
      <hr className="mt-1 mb-1" style={{ backgroundColor: "#D1D1D6" }}></hr>

      {/* dropdown  */}
      <div className="row mt-3">
        <div className="col-md-6 mb-3">
          <label className="fw-semibold mb-1">
            User Type <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={optionList.userType}
            value={data?.userType}
            onChange={(e) => {
              handleChange("userType", e);
            }}
            isDisabled={true}
            placeholder="Select User Type"
            styles={customStyles}
          />
          {errors && !data?.userType && <p className="err">Select User Type</p>}
        </div>
        <div className="col-md-6 mb-3">
          <label className="fw-semibold mb-1">
            Type <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={optionList?.Type}
            value={data?.Type}
            onChange={(e) => {
              handleChange("Type", e);
              setIsVideo(e.value === 1);
            }}
            isDisabled={true}
            placeholder="Select Type"
            styles={customStyles}
          />
          {errors && !data?.Type && <p className="err">Select Type</p>}
        </div>
      </div>

      {/* languages  */}

      <div className="d-flex  ac-js mt-3 gap-2 pv-3 overflow-auto">
        {optionList.languages?.map((lan) => {
          return (
            <div className="px-3 border-right-gray pointer">
              <div
                onClick={() => {
                  handleChangeData(lan);
                }}
                className={`${data?.language?.id === lan?.id ? "border-bottom-line" : ""}  px-3 py-2`}
              >
                <p
                  className="text-center fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 "
                  style={{
                    color:
                      data?.language?.id === lan?.id ? "#AE55F5" : "#6B7280",
                  }}
                >
                  {lan?.name}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {errors && !data?.language && <p className="err mt-1">Select Language</p>}

      {/* video section  */}
      <div className="col-12 d-flex as-jb mt-5">
        {/* video upload section */}
        <div className="col-6">
          <div className="col-10">
            <label className="fw-semibold mb-1">
              Upload {isVideo ? "Video" : "Banner"}
            </label>
            {errors &&
              ((isVideo && !data?.video) || (!isVideo && !data?.thumbnail)) && (
                <p className="err mt-1">
                  Upload {isVideo ? "Video" : "Banner"}
                </p>
              )}
                      <UploadVideo
                          isDisabled={!isEdit}
              isBanner={!isVideo}
              video={isVideo ? data?.video : data?.thumbnail}
              setVideo={(e) => handleChange(isVideo ? "video" : "thumbnail", e)}
            />

            <label className="fw-semibold  mt-3">
              Announcement Banner/Video
            </label>
            <p className="text-danger mt-1">Max Upload Size : 75MB</p>
            {isVideo && (
              <p className="text-danger  mt-1">
                Max Duration : <span className="black">2:00 mins</span>*
              </p>
            )}
          </div>
        </div>
        {/* video details section  */}
        <div className="col-6">
          <div className="col-11">
            {/* thumbnail  */}
            {isVideo && (
              <div className=" mb-3 col-12">
                <label className="fw-semibold mb-1">Thumbnail Image</label>
                <div className="form-controls d-flex ac-jb">
                  <p className="">
                    {data?.thumbnail?.name ??
                      data?.thumbnail?.split("/")?.at(-1)}
                  </p>
                  <input
                    name="userName"
                    ref={thumpRef}
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleChange("thumbnail", e.target.files[0])
                    }
                    style={{ display: "none" }}
                    placeholder="Enter Receptionist Name"
                  />
                  <div
                    onClick={() => thumpRef.current.click()}
                    class="pointer video-left-line ps-2"
                  >
                    <FileUploadOutlinedIcon
                      htmlColor="#3C3C4399"
                      fontSize="small"
                    />
                  </div>
                </div>
                {errors && !data?.thumbnail && (
                  <p className="err mt-1">Upload Thumbnail</p>
                )}
              </div>
            )}
            {/* video title  */}
            <div className=" mb-3 col-12">
              <label className="fw-semibold mb-1">
                {isVideo ? "Video" : "Banner"} Title
              </label>
              <input
                value={data?.title}
                className="form-controls"
                placeholder=" Title"
                onChange={(e) => handleChange("title", e.target.value)}
              />

              {errors && !data?.title && (
                <p className="err mt-1">Enter Title</p>
              )}
            </div>
            {/* display For  */}
            {data?.userType?.value === 2 && (
              <div className="mb-3 col-12">
                <div className="d-flex ac-jb">
                  <label className="fw-semibold mb-1">Display For</label>

                  <div className="d-flex ac-jc">
                    <div
                      onClick={() =>
                        handleChange(
                          "displayFor",
                          data?.displayFor?.length ===
                            optionList?.displayFor?.length
                            ? []
                            : optionList?.displayFor,
                        )
                      }
                      style={{
                        backgroundColor:
                          data?.displayFor?.length ===
                          optionList?.displayFor?.length
                            ? "#58CC02"
                            : "#fff",
                        borderColor:
                          data?.displayFor?.length ===
                          optionList?.displayFor?.length
                            ? "#58CC02"
                            : undefined,
                      }}
                      className={`check-box-btn d-flex ac-jc`}
                    >
                      {data?.displayFor?.length ===
                        optionList?.displayFor?.length && (
                        <DoneIcon
                          htmlColor="#fff"
                          style={{ height: "15px", width: "15px" }}
                          fontSize="small"
                        />
                      )}
                    </div>
                    <p className="f2 ms-2">Select All</p>
                  </div>
                </div>
                {errors && data?.displayFor?.length === 0 && (
                  <p className="err mt-1">Select Display For</p>
                )}
                <div className="row g-2 mt-2">
                  {optionList?.displayFor?.map((item, ind) => {
                    return (
                      <div key={ind} className={"col-6"}>
                        <div className="border p-2 rounded-2 d-flex ac-jb">
                          <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 ">
                            {item}
                          </p>
                          <div
                            onClick={() =>
                              handleCheckBoxChange("displayFor", item)
                            }
                            style={{
                              backgroundColor: data?.displayFor?.includes(item)
                                ? "#58CC02"
                                : "#fff",
                              borderColor: data?.displayFor?.includes(item)
                                ? "#58CC02"
                                : undefined,
                            }}
                            className={`check-box-btn d-flex ac-jc`}
                          >
                            {data?.displayFor?.includes(item) && (
                              <DoneIcon
                                htmlColor="#fff"
                                style={{ height: "15px", width: "15px" }}
                                fontSize="small"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* submit buttons  */}
            {isEdit &&(<div className="d-flex gap-2">
              <button
                onClick={() => {
                  naviagte(-1);
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 video-submit-btn "
              >
                cancel
              </button>{" "}
              <button
                onClick={Submit}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 border-0 white bg-primary1 video-submit-btn"
              >
                {isEdit ? "Edit" : "Save"}
              </button>
            </div>)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBannerEdit;
